import axiosInstance from "../axiosConfig";

// Stored submissions of the end-user home page "Find your licenses" form
const getLicenseFinderLeads = async ({ queryKey }) => {
  const [, filters] = queryKey;
  // Drop empty filters so the API falls back to its defaults
  const params = Object.fromEntries(
    Object.entries(filters).filter(([, value]) => !!value)
  );
  return await axiosInstance.get(`/api/list-license-finder-leads`, { params });
};

const LicenseFinderLeadsService = { getLicenseFinderLeads };

export default LicenseFinderLeadsService;
